// Filters Controller for Business Directory
import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input"]
  static values = { 
    url: String,
    debounceDelay: { type: Number, default: 300 }
  }

  connect() {
    this.timeout = null
    this.formData = new FormData()
    
    // Initialize form data with current values
    this.inputTargets.forEach(input => {
      if (input.checked || (input.type !== 'checkbox' && input.type !== 'radio')) {
        if (input.value) {
          this.formData.set(input.name, input.value)
        }
      }
    })
  }

  disconnect() {
    if (this.timeout) {
      clearTimeout(this.timeout)
    }
  }

  updateFilter(event) {
    const input = event.target
    
    // Clear any existing timeout
    if (this.timeout) {
      clearTimeout(this.timeout)
    }

    // Update form data
    this.updateFormData(input)

    // Debounce the update
    this.timeout = setTimeout(() => {
      this.submitFilters()
    }, this.debounceDelayValue)
  }

  updateRangeDisplay(event) {
    const input = event.target
    const display = input.parentElement.querySelector('label')
    if (display) {
      display.textContent = `Within ${input.value} miles`
    }
  }

  updateFormData(input) {
    if (input.type === 'checkbox') {
      if (input.checked) {
        this.formData.set(input.name, input.value)
      } else {
        this.formData.delete(input.name)
      }
    } else if (input.type === 'radio') {
      if (input.checked) {
        this.formData.set(input.name, input.value)
      }
    } else {
      if (input.value) {
        this.formData.set(input.name, input.value)
      } else {
        this.formData.delete(input.name)
      }
    }
  }

  submitFilters() {
    // Build URL with query parameters
    const url = new URL(this.urlValue, window.location.origin)
    
    // Add form data as search params
    for (const [key, value] of this.formData.entries()) {
      url.searchParams.set(key, value)
    }

    // Update browser history
    window.history.pushState({}, '', url.toString())

    // Fetch and update content
    fetch(url.toString(), {
      headers: {
        'Accept': 'text/vnd.turbo-stream.html',
        'Turbo-Frame': 'businesses_grid'
      }
    })
    .then(response => response.text())
    .then(html => {
      // Find the turbo frame and update it
      const frame = document.querySelector('#businesses_grid')
      if (frame) {
        frame.innerHTML = html
      }
    })
    .catch(error => {
      console.error('Filter update failed:', error)
    })
  }

  clearAll(event) {
    event.preventDefault()
    
    // Clear all inputs
    this.inputTargets.forEach(input => {
      if (input.type === 'checkbox' || input.type === 'radio') {
        input.checked = false
      } else {
        input.value = ''
      }
    })

    // Clear form data
    this.formData = new FormData()

    // Navigate to clean URL
    window.location.href = this.urlValue
  }

  // Helper method to get current filter state
  getCurrentFilters() {
    const filters = {}
    for (const [key, value] of this.formData.entries()) {
      filters[key] = value
    }
    return filters
  }

  // Method to apply filters from external source (e.g., search suggestions)
  applyFilters(filters) {
    Object.entries(filters).forEach(([key, value]) => {
      const input = this.inputTargets.find(el => el.name === key)
      if (input) {
        if (input.type === 'checkbox' || input.type === 'radio') {
          input.checked = input.value === value
        } else {
          input.value = value
        }
        this.updateFormData(input)
      }
    })

    this.submitFilters()
  }
}
